import React from 'react';
import './ListHistorico.css';
import PropTypes from 'prop-types';
import services from './../../services/index'




const ListHistorico = props => {

  if (props.pedidos.length === 0) {
    return <p style={{fontSize: '32px', textAlign:'center', color :'#fff'}}>Não há histórico de Pedidos</p>
  } else {



    return (
      <div>
          
        {
          props.pedidos.map(item => {
            
            let status = item.status;
            let colorStatus = '#27ae60';
            
            if(status === 'CANCELADO'){
              colorStatus = '#C3000D';
            }else if(status === 'INTEGRADO'){
              status = 'RECEBIDO';
            }else if(status === 'PENDENTE'){
              colorStatus = '#C3000D';
            }

            return (
              <div>                
              <div className="col-md-6"  key={item.codigo_pedido}>
                <div className="item-historico">
                  <div className="row">
                    <div className="col-md-12">
                      <h2>Pedido # {item.codigo_pedido}</h2>

                      <div className="row">
                        <div className="col-md-6 col-sm-6 col-xs-6">
                          <p>Data do Pedido </p>
                        </div>


                        <div className="col-md-6 col-sm-6 col-xs-6">
                          <p className="text-right">
                            {
                              services.formatDate(item.data)
                            }
                          </p>
                        </div>
                      </div>


                      <div className="row">
                        <div className="col-md-6 col-sm-6 col-xs-6">
                          <p>Loja </p>
                        </div>


                        <div className="col-md-6 col-sm-6 col-xs-6">
                          <p className="text-right">{item.loja}</p>
                        </div>
                      </div>


                      <div className="row">
                        <div className="col-md-6 col-sm-6 col-xs-6">
                          <p className="pStatusLabel">Status do Pedido</p>
                        </div>


                        <div className="col-md-6 col-sm-6 col-xs-6">
                          {/* <p className="text-right pStatus" style={{ color: item.status === 'INTEGRADO' ? '#27ae60' : '#C3000D' }}>
                            {item.status === 'INTEGRADO' ? 'RECEBIDO' : 'PENDENTE'}
                          </p> */}
                          <p className="text-right pStatus" style={{ color: colorStatus}}>
                            {status}
                          </p>
                        </div>
                      </div>



                      <div className="row">
                        <div className="col-md-6 col-sm-6 col-xs-6">
                          <p>Taxa de Entrega</p>
                        </div>


                        <div className="col-md-6 col-sm-6 col-xs-6">
                          <p className="text-right">R$ {item.taxa ? item.taxa.toFixed(2) : '0.00'}</p>
                        </div>
                      </div>


                      <div className="row">
                        <div className="col-md-6 col-sm-6 col-xs-6">
                          <p className="tot-label-historico">Total do Pedido</p>
                        </div>


                        <div className="col-md-6 col-sm-6 col-xs-6">
                          <p className="text-right tot-historico">R$ {item.total_pedido.toFixed(2)}</p>
                        </div>
                      </div>

                    </div>
                  </div>
                  <button type="button" className="btn btn-mais-itens btnMostra" onClick={()=>props.openPedido(item.codigo_pedido)}>Mostrar Itens</button>
                  {/* <button type="button" className="btn btn-primary btn-mais-itens btnRepetir" onClick={()=>props.repetirPedido(item.codigo_pedido)}>Repetir Pedido</button> */}
                </div>
         
              </div>
              </div>

            )
          })
        }
      </div>
    )
  }
}


// ListHistorico.propTypes = {
//   pedidos : PropTypes.array.isRequired
// }


export default ListHistorico;